const KEY = "ubbi-theme";

export function currentTheme() {
  return document.documentElement.getAttribute("data-theme") || "light";
}

export function setTheme(next) {
  document.documentElement.setAttribute("data-theme", next);
  localStorage.setItem(KEY, next);
}

export function toggleTheme() {
  setTheme(currentTheme() === "dark" ? "light" : "dark");
}
